import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class Notifications {
  private readonly messageService = inject(MessageService);
  success(message: string): void {
    this.messageService.add({
      key: 'global',
      severity: 'success',
      detail: message,
      life: 4000,
    });
  }
  error(message: string): void {
    this.messageService.add({
      key: 'global',
      severity: 'error',
      detail: message,
      life: 7000,
    });
  }
}
